import styled, { css } from 'styled-components';

import { colors } from 'global/colors';

export const HeadingButtonContainer = styled.div`
  display: flex;
  justify-content: end;
  gap: 5px;
`;

export const DropDownListContainer = styled.div`
  position: absolute;
  z-index: 100;
  width: 146px;
  margin-top: 10px;
  margin-left: -16px;
`;

export const DropDownList = styled.ul`
  padding: 0px !important;
  margin: 0;
  padding-left: 1em;
  background: #ffffff;
  border: 2px solid #e5e5e5;
  box-sizing: border-box;
  color: #3faffa;
  font-size: 12px;
  font-weight: 500;
  text-align: left;
  &:first-child {
    padding-top: 0.8em;
  }
`;

export const ListItem = styled.li`
  list-style: none;
  cursor: pointer;
  color: #285c87;
  padding-left: 15px;
  line-height: 28px;
  &:hover {
    background-color: #f8f9fa;
  }
`;

export const HeaderContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-bottom: 10px;

  @media (max-width: 768px) {
    flex-direction: column;
    height: 75px;
  }
`;

export const ContentContainer = styled.div`
  margin-top: 0.5rem;
  display: flex;

  @media (max-width: 576px) {
    flex-direction: column;
  }
  ${(props) =>
    props.center &&
    css`
      justify-content: center;
    `}
`;

export const LeftContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 220px;
  margin-right: 10px;

  @media (max-width: 576px) {
    margin-right: 0;
    margin-bottom: 10px;
  }
`;

export const RightContainer = styled.div`
  width: 100%;
`;

export const RightHeaderContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-end;
  align-items: center;
  @media (max-width: 768px) {
    justify-content: flex-end;
    margin-top: 4px;
  }
`;

export const SortByLabel = styled.span`
  font-size: 15px;
  color: ${colors.darkGray};
  margin: 0 5px 0;
`;
